import {
  Button, Card, CardActions, CardContent, CardHeader, TextField,
  CircularProgress, Dialog, Grid, DialogActions, DialogContent,
  DialogContentText, DialogTitle, Divider, IconButton, Typography,
  List, ListItem, ListItemText, MenuItem, createMuiTheme, ListItemSecondaryAction,
  ListItemAvatar, Avatar, ButtonGroup, ClickAwayListener, Grow, Paper, Popper, MenuList
} from '@material-ui/core';
import PropTypes from 'prop-types';
import React, { Fragment, useEffect } from 'react';
import { connect, useSelector } from 'react-redux';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/styles';
import { useTranslation } from 'react-i18next';
import { CheckCircle, HourglassEmptyOutlined } from '@material-ui/icons';
import { red, green } from '@material-ui/core/colors';
import TechnicianSurveyDetails from 'src/components/TechnicianSurveyDetails';
import axios from 'src/utils/axios';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import ErrorMessage from 'src/components/ErrorMessage';

const useStyles = makeStyles((theme) => ({
  root: {},
  content: {
    minHeight: 400,
  },
  submitButton: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1)
  },

}));

function TechnicianSurvey({
  className, workorderId, readonly, loadedSurveys, getTechnicianWorkOrderSurveys, handleSurveyClickReload
}) {
  const { t } = useTranslation('work_order');
  const classes = useStyles();
  const [survey, setsurvey] = React.useState();
  const [surveyDetailsOpen, setsurveyDetailsOpen] = React.useState(false);
  const [questionsOptionsAnswers, setquestionsOptionsAnswers] = React.useState([]);
  const isOnline = useSelector((state) => state.status?.isOnline)


  const reloadSurveys = () => {
    getTechnicianWorkOrderSurveys();
  }

  const getTechnicianSurveyQuestionsAnswers = (surveyId, openSurveyModal) => {
    axios
      .get(
        `/GetTechnicianSurveyQuestionsAnswers/${surveyId}/${workorderId}`
      )
      .then(response => {
        if (response.data == null || response.data.StatusCode != 200) {
          console.error("An error occured while fetching survey questions/answers. Please check error logs.");
        }
        else {
          setquestionsOptionsAnswers(response.data.Result);

          setsurveyDetailsOpen(openSurveyModal);


        }
      })
      .catch(error => {
        console.error(error);

      });
  }
  const handleSurveyDetailsClose = (surveyId) => {
    setsurveyDetailsOpen(false);
    setsurvey(null);

  };

  const handleSurveyClick = (event, survey) => {
    setsurvey(survey);
  };

  useEffect(() => {
    if (survey != null && survey.Id != 0) {

      getTechnicianSurveyQuestionsAnswers(survey.Id, true);

    }
  }, [survey]);





  return (
    <div>
      {isOnline ? (
        <Fragment>
          <Card
            className={clsx(classes.root, className)}
          >
            <CardHeader
              title={t('Anket')}
            />
            <Divider />
            <CardContent className={classes.content}>
              <List className={classes.root}>
                {loadedSurveys.map((survey) => (

                  <ListItem display="flex" p={1}
                  // button
                  //  onClick={(event) => handleSurveyClick(event, survey)}>
                  >
                    <ListItemAvatar p={1} flexGrow={1}>
                      {survey.IsCompleted &&
                        <CheckCircle fontSize='large' />
                      }
                      {!survey.IsCompleted &&
                        <HourglassEmptyOutlined fontSize='large' />
                      }
                    </ListItemAvatar>
                    <ListItemText
                      flexGrow={1}
                      primary={survey.Title}
                      secondary={
                        <React.Fragment>
                          <Typography
                            component="span"
                            variant="body2"
                            className={classes.inline}
                            color="textPrimary"
                          >
                            {new Date(survey.CreatedDate).toLocaleDateString('en-US')}
                          </Typography>
                          <br />
                          {survey.Description}
                        </React.Fragment>
                      }
                    />
                    {survey.IsCompleted &&
                      <Button variant="contained" color="primary" onClick={(event) => handleSurveyClick(event, survey)}>
                        See Answers
                      </Button>
                    }
                    {!survey.IsCompleted &&

                      <Button variant="contained" color="primary" onClick={(event) => handleSurveyClick(event, survey)}>
                        Start Survey
                      </Button>
                    }

                  </ListItem>
                ))}

                <Divider variant="inset" component="li" />
              </List>
            </CardContent>
          </Card>

          <TechnicianSurveyDetails
            onClose={handleSurveyDetailsClose}
            survey={survey}
            surveyQuestionAnswers={questionsOptionsAnswers}
            workOrderId={workorderId}
            open={surveyDetailsOpen}
            reloadSurveysList={reloadSurveys}
            handleSurveyClickReload={handleSurveyClick}
          />
        </Fragment>
      ) : (
        <Card>
          <CardContent>
            <ErrorMessage message={t('Offline_Message')} />
          </CardContent>
        </Card>
      )}
    </div>


  );
}

TechnicianSurvey.propTypes = {
  className: PropTypes.string,
  workorderId: PropTypes.number,
  loadedSurveys: PropTypes.array
};


export default TechnicianSurvey;

